import { unitString } from '../../../../hooks/useUnitsString'
import { ISocietiesModel } from '../../../../interfaces/models/societies.interfaces'
import { ISocietyEntranceModel } from '../../../../interfaces/models/society-entrance.interfaces'
import { IUnitModel } from '../../../../interfaces/models/units.interfaces'
import { NBinder } from '../../../../interfaces/services/binder.interfaces'

export type BinderType = {
  unitId: string
  function?: () => void
  adress: string
  aptNumber: string
  floor: number
  fileCount?: number
  folderCount?: number
  publishedAt?: string | null
}

export const mapUnitToBinderType = (
  unit: IUnitModel,
  society?: ISocietiesModel,
  societyEntrences?: ISocietyEntranceModel[],
  binderSummary?: NBinder.NGetAllBinders.IBinderSummary
): BinderType => {
  const _unitString = unitString(
    unit ? [unit] : [],
    society ? [society] : [],
    societyEntrences || [],
    true
  )
  return {
    unitId: unit._id,
    adress: _unitString,
    aptNumber: unit.titleLegal ?? '',
    floor: unit.floor ?? 0,
    fileCount: binderSummary?.fileCount ?? 0,
    folderCount: binderSummary?.folderCount ?? 0,
    publishedAt: binderSummary?.publishedAt ?? null,
  }
}
